// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"b523c980","436":"7f9f5085","453":"6ad60e51"}[chunkId] + ".chunk.js";
};